import "../../index24.css";
import { jsx as r } from "react/jsx-runtime";
import { useRef as c } from "react";
import { _ as a } from "../../cs-Dfox81s-.js";
import "../../type-Dku6Xzl6.js";
const d = "_heading_1xe3z_1", x = "_center-aligned_1xe3z_11", z = "_level-one_1xe3z_15", g = "_level-two_1xe3z_23", m = "_level-three_1xe3z_31", f = "_level-four_1xe3z_40", h = "_level-five_1xe3z_44", p = "_level-six_1xe3z_48", u = "_ellipsized_1xe3z_54", e = {
  heading: d,
  centerAligned: x,
  levelOne: z,
  levelTwo: g,
  levelThree: m,
  levelFour: f,
  levelFive: h,
  levelSix: p,
  ellipsized: u
}, T = {
  1: e.levelOne,
  2: e.levelTwo,
  3: e.levelThree,
  4: e.levelFour,
  5: e.levelFive,
  6: e.levelSix
};
function S(i) {
  const {
    className: o,
    level: l = 3,
    children: n,
    ellipsize: s,
    centerAligned: t
  } = i, v = `h${l}`, _ = c(null);
  return n ? /* @__PURE__ */ r(
    v,
    {
      className: a(
        e.heading,
        s && e.ellipsized,
        T[l],
        t && e.centerAligned,
        o
      ),
      ref: _,
      children: n
    }
  ) : null;
}
export {
  S as default
};
